import { Anchor, Box, Flex, Paper, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { IByStatus, IDashboard } from "../../../models/Dashboard"
import { currencyFormat } from "../../../utils"
import { CardHeader } from "./CardHeader"
import { STATUS_COLOR } from "../utils"
import classes from "../real.module.css"

interface Props {
  byStatus: IDashboard["byStatus"] | undefined
  onViewAll: () => void
}

export function OrderStatusCard({ byStatus, onViewAll }: Props) {
  const { t } = useTranslation(["dashboard", "common"])
  const filtered = (byStatus ?? []).filter((s: IByStatus) => s.orderCount > 0)
  const maxCount = Math.max(...filtered.map((s) => s.orderCount), 1)

  return (
    <Paper className={classes.card}>
      <CardHeader
        title={t("dashboard:table.orderStatus")}
        subtitle={`${t("dashboard:statusSub", { defaultValue: "Төлөв бүрээр" })} · ${t("dashboard:allTime")}`}
        right={
          <Anchor onClick={onViewAll} className={classes.seeAll}>
            {t("dashboard:viewAll")}
          </Anchor>
        }
      />

      {filtered.length === 0 ? (
        <Text fz={14} c="dimmed" ta="center" py="md">
          -
        </Text>
      ) : (
        <Flex direction="column">
          {filtered.map((item, index) => (
            <StatusRow key={index} item={item} maxCount={maxCount} />
          ))}
        </Flex>
      )}
    </Paper>
  )
}

function StatusRow({ item, maxCount }: { item: IByStatus; maxCount: number }) {
  // The backend sends the status colour; the name map is only a fallback.
  const color = item.color || STATUS_COLOR[item.name] || "var(--mantine-color-gray-5)"
  const barWidth = Math.max((item.orderCount / maxCount) * 100, 6)

  return (
    <Box className={classes.statusItem}>
      <Flex justify="space-between" align="center" mb={4}>
        <Flex align="center" gap={6}>
          <Box className={classes.statusDot} style={{ background: color }} />
          <Text className={classes.statusName}>{item.name}</Text>
        </Flex>
        <Flex align="center" gap={8}>
          <Text className={classes.statusCount}>{item.orderCount}</Text>
          <Text className={classes.statusAmount}>{currencyFormat(item.orderAmount || 0)}</Text>
        </Flex>
      </Flex>
      <Box className={classes.statusBar}>
        <Box className={classes.statusBarFill} style={{ width: `${barWidth}%`, background: color }} />
      </Box>
    </Box>
  )
}
